<script setup lang="ts">
import NuxtImg, {
  imgProps,
} from "../node_modules/@nuxt/image/dist/runtime/components/NuxtImg.vue";

// eslint-disable-next-line vue/define-props-declaration
defineProps({
  ...imgProps,
  alt: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <NuxtImg v-bind="{ ...$attrs, ...$props }" />
</template>
